import { render, staticRenderFns } from "./PurchaseOrdersAdd.vue?vue&type=template&id=152502b6&scoped=true"
import script from "./PurchaseOrdersAdd.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersAdd.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrdersAdd.vue?vue&type=style&index=0&id=152502b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152502b6",
  null
  
)

export default component.exports